"use strict";

require("core-js/modules/es.symbol.description.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _toolkit = require("@reduxjs/toolkit");
var _reduxSaga = _interopRequireDefault(require("redux-saga"));
var _invariant = _interopRequireDefault(require("invariant"));
var _lodash = require("lodash");
var _devices = require("../../entities/devices");
var _sockets = require("../../entities/sockets");
var _user = require("../../entities/user");
var _translations = require("../../entities/translations");
var _sites = require("../../entities/sites");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const sagaMiddleware = (0, _reduxSaga.default)();
const core = (0, _toolkit.combineReducers)({
  user: _user.user,
  devices: _devices.devices,
  sites: _sites.sites,
  translations: _translations.translations,
  sockets: _sockets.sockets
});
let store = exports.store = null;
const createInjectorsEnhancer = params => {
  (0, _invariant.default)((0, _lodash.conformsTo)(params, {
    runSaga: _lodash.isFunction,
    createReducer: _lodash.isFunction
  }), '(redux-injectors...) createInjectorsEnhancer: params `runSaga` and ' + '`createReducer` are required.');
  return createStore => function () {
    const store = createStore(...arguments);
    return _objectSpread(_objectSpread({}, store), {}, {
      createReducer: params.createReducer,
      runSaga: params.runSaga,
      injectedReducers: {},
      // Reducer registry
      injectedSagas: {} // Saga registry
    });
  };
};

const configureStore = function configureStore() {
  let initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  const createReducer = function createReducer() {
    let injectedReducers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, _toolkit.combineReducers)(_objectSpread({
      core
    }, injectedReducers));
  };
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    shouldHotReload: false
  }) : _toolkit.compose;
  exports.store = store = (0, _toolkit.createStore)(createReducer(), initialState, composeEnhancers((0, _toolkit.applyMiddleware)(sagaMiddleware), createInjectorsEnhancer({
    createReducer,
    runSaga: sagaMiddleware.run
  })));
  return store;
};
var _default = exports.default = configureStore;